import { render, staticRenderFns } from "./GaoPaiYiCamera.vue?vue&type=template&id=6c69aabb&scoped=true&"
import script from "./GaoPaiYiCamera.vue?vue&type=script&lang=js&"
export * from "./GaoPaiYiCamera.vue?vue&type=script&lang=js&"
import style0 from "./GaoPaiYiCamera.vue?vue&type=style&index=0&id=6c69aabb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c69aabb",
  null
  
)

export default component.exports